import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PdfViewerComponent } from '../file-viewers/pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'app-document-viewer-blob-storage',
  templateUrl: './document-viewer-blob-storage.component.html',
  styleUrls: ['./document-viewer-blob-storage.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [PdfViewerComponent],
})
export class DocumentViewerBlobStorageComponent {
  @Input() document: Blob;

  previewDocLoaded: boolean;
}
